export default __webpack_public_path__ + "static/169RU-38924ad41b6838d6c53124b51de65eca.png";